/**
 * traces stream — coming soon
 *
 * WHY NOT WIRED: No SSE streaming endpoint exists on the BE.
 * SDK has no streaming method for traces.
 *
 * WHEN TO WIRE: Once the BE adds a real-time trace SSE endpoint
 * (e.g., GET /api/traces/stream) and the SDK exposes it, replace
 * the guard below with a real EventSource/SSE consumer.
 */

import { Command } from 'commander';
import chalk from 'chalk';
import { getJsonFlag } from '../../lib/output.js';
import { getAppBaseUrl } from '../../lib/ui-links.js';

export function registerStreamCommand(parent: Command): void {
  parent
    .command('stream')
    .description('Stream traces in real-time (coming soon)')
    .addHelpText('after', `
Examples:
  ${chalk.dim('$')} mutagent traces stream
  ${chalk.dim('$')} mutagent traces stream --json

${chalk.dim('Real-time trace streaming via SSE.')}
${chalk.yellow('NOTE: This command is not yet connected to the API.')}
    `)
    .action(() => {
      const isJson = getJsonFlag(parent);

      if (isJson) {
        console.log(JSON.stringify({
          status: 'coming_soon',
          message: 'Real-time trace streaming is not yet available. Use "mutagent traces list" to poll, or view live traces on the dashboard.',
        }));
      } else {
        console.log(chalk.yellow('\n  ⚠  Real-time trace streaming is not yet available — coming soon.\n'));
        console.log(chalk.dim('  In the meantime, use:'));
        console.log(chalk.dim('    mutagent traces list --json    (poll for new traces)'));
        console.log(chalk.dim(`    ${getAppBaseUrl()}/observe/traces  (live dashboard)\n`));
      }
    });
}
